import Vue from 'vue'
import Vuex from 'vuex'
import { localStorage } from '@/util/chrome.api'
import { saveState } from '@/util/localstorage'

import user from './user'
import star from './star'
import icon from './icon'
import starEdit from './starEdit'
import event from './event'

Vue.use(Vuex)
console.log('store init')
export default new Vuex.Store({
  modules: {
    user,
    star,
    icon,
    starEdit,
    event,
  },
  state: {
    broadcast: null,
    animating: false,
    bigMode: false,
    darkMode: false,
    showUpgrade: false,
    loading: false,
    showTokenDialog: false,
    lang: window.localStorage.getItem('lang') || navigator.language,
  },
  namespaced: true,
  mutations: {
    /**
     * 全局广播
     */
    setBroadcast(state, msg) {
      state.broadcast = msg
    },
    showUpgrade(state) {
      console.log('commit showupgrade')
      state.showUpgrade = true
    },
    hideUpgrade(state) {
      state.showUpgrade = false
    },
    toggleLoading(state, status) {
      state.loading = status
    },
    startAnimate(state) {
      state.animating = true
    },
    stopAnimate(state) {
      state.animating = false
    },
    showTokenDialog(state) {
      state.showTokenDialog = true
    },
    hideTokenDialog(state) {
      state.showTokenDialog = false
    },
    setSizeMode(state, mode) {
      state.bigMode = mode === '1'
      saveState('bigMode', mode)
    },
    setDarkMode(state, mode) {
      state.darkMode = (mode === '1' || mode === 1)
      saveState('darkMode', mode)
    },
    setLang(state, lang) {
      state.lang = lang
    },
  },
  actions: {
    async switchLang({ commit }, lang) {
      await saveState('lang', lang)
      commit('setLang', lang)
    },
    /**
     * 初始化基本设置数据
     * @param {} param0
     */
    async initSettingState({ commit }) {
      let darkMode
      try {
        darkMode = await localStorage({ type: 'getLocalStorage', key: 'darkMode' })
        darkMode = darkMode + ''
      } catch (e) {
        darkMode = window.localStorage.getItem('darkMode')
        darkMode = darkMode === undefined ? darkMode : darkMode + ''
      }
      const darkMedia = (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? '1' : '0'
      commit('setDarkMode', darkMode || darkMedia)
    },
  },
})
